import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import UserAdminListView from "./UserAdminListView";
import UserAdminNewView from "./UserAdminNewView";
import UserAdminDetailsView from "./UserAdminDetailsView";


const UserAdmin = () => {

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const location = useLocation();

  // The existance of location.state indicated a redirect from the Manage Admin
  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState((location && location.state && location.state.user) ? location.state.user : {} );
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // ##### NOT SURE WHAT THE BELOW CODE DOES.  MAY NEED TO REMOVE. #####
    // Receiving re-direction from Admin Management page for Admin details and updates
    if (   location.state
        && location.state.user) {

      setObjDetails(location.state.user);
      setUIMode('UserDetails');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <UserAdminListView    pageState={pageState} onUIMode={setUIMode}
                                                      onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <UserAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <UserAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default UserAdmin;
